<template>
    <div >
        <select class="form-select form-control mb-2" v-model="selectedStatus" @change="getWalletHistory(true)">
            <option v-for="(item, index) in options" :key="index" :value="item.value">{{ item?.label }}</option>
        </select>
        <div class="table-responsive">
            <table class="table table-bordered withdraw-table" id="withdrawTable">
                <thead>
                    <tr>
                        <th>{{ $t('date', 'Requested Date') }}</th>
                        <th>{{ $t('payment-type', 'Payment Type') }}</th>
                        <th>{{ $t('payment-type', 'Payment Method') }}</th>
                        <th>{{ $t('amount', 'Requested Amount') }}</th>
                        <th>{{ $t('status', 'Status') }}</th>
                        <th>Approved Amount</th>
                        <th>{{ $t('action', 'Action Date') }}</th>
                        <!-- <th>{{ $t('payment-method', 'Payment Method') }}</th> -->
                        <th>{{ $t('transaction-no', 'Transaction No') }}</th>
                        <!-- <th>{{ $t('utr-no', 'UTR No') }}</th> -->
                        <th>{{ $t('reason', 'Reason') }}</th>
                        <th>Attachment</th>
                    </tr>
                </thead>
                
                <tbody v-if="historyData && historyData.length > 0" id="depositTableData">
                    <tr v-for="(item,index) in historyData" :key="index" class="text-center">
                        <td>{{ $dateTime.getLocalDate(item?.created_at, 'DD MMM h:mm A') }}</td>
                        <td>{{toTitleCaseWithSpaces(item?.type)}}</td>
                        <td>{{item?.payment_method ||'-'}}</td>
                        <td>{{ item?.amount || '-' }}</td>
                        <td>
                            <div class="d-flex align-items-center justify-content-center">
                                <span class="depositStatus" :class="getTransactionStatus(item?.status)?.class" >
                                    {{ getTransactionStatus(item.status)?.label }}
                                </span>
                                <i v-if="['pending', 'approve_in_process', 'reject_in_process','hold'].includes(item.status)" @click="handleRefreshWalletHistory(index)" :id="'spin'+index" class="fa ms-1 fa-refresh" aria-hidden="true"></i>                
                            </div>
                        </td>  
                        <td >{{ item?.approved_amount || '-' }}</td>
                        <td>
                            <div class="history-wet credit-color transactionsInformation-delete" v-if="item.status == 'pending'">
                                -
                            </div>
                            <span v-else>{{ item.status == 'hold' ? (item?.hold_at ? $dateTime.getLocalDate(item?.hold_at, 'DD MMM h:mm A') : '-') : (item?.action_at ? $dateTime.getLocalDate(item?.action_at, 'DD MMM h:mm A') : '-')}}</span>
                        </td>
                        <td>{{ item?.transaction_id || '-' }}</td>
                        <td class="remarkTD">{{item.remark || '-' }}</td>
                        <td>
                            <div class="wallet-view-btn-main" v-if="item?.transaction_image_url">
                                <button type="button" class="view-tran-btn12" @click="currentImgUrl = item?.transaction_image_url" data-bs-toggle="modal" data-bs-target="#transactionModal">{{ $t('view-details','View details') }}</button>
                            </div>
                            <div v-else>-</div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="10" class="no-data-found-td">
                            No data found!
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
     <!-- transaction details modal -->
    <div class="modal fade history-filter-modal transaction_detail_modal" id="transactionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
         <div class="modal-content">
            <div class="modal-header ">
                <h5 class="text-capitalize-random">{{ $t('details','Details')}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="text-center" v-if="currentImgUrl">
                    <div class="transactionImage-wrap">
                        <div class="transactionImage-item" v-for="(item,index) in transactionImageLists" :key="index">
                            <a :href="item" download target="_blank">
                                <img :src="item" height="100%" width="100px" />
                            </a>
                        </div>
                    </div>
                </div>
               <div class="transactionImage-wrap" v-else>
                  <p class="text-center" style="color: #000;">{{ $t('no-record-found','No Record found') }}</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import {getWalletHistory, getTransactionStatus, cancelRequest} from "../services/walletHistory"
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
export default {
    name: 'WalletHistory',
    components: {
		NoDataFound,
    },
    data() {
        return {
            formDates:{
                fromDate: '',
                toDate: '',
            },
            options: [
                { label: this.$t('all', 'All'), value: 'all', selected:true },
                { label: this.$t('pending', 'Pending'), value: 'pending', selected:true },
                { label: this.$t('approved', 'Approved'), value: 'approve_completed', selected:true },
                { label: this.$t('rejected', 'Rejected'), value: 'reject_completed', selected:true },
                { label: this.$t('processing', 'Processing'), value: 'processing', selected:true },
                { label: this.$t('expired', 'Expired'), value: 'expired', selected:true },
                
            ],
            select_entries: 50,
            walletHistoryData: [],
            todayDate: new Date().toISOString().split('T')[0],
            spinClass: false,
            historyCallInterval: null,
            selectedStatus: 'all', // Default to 'Pending',
            selectedTransactionId: null,
            currentImgUrl: '',
        }
    },
    computed: {
        historyData() {
            let Data;
            if(this.selectedStatus == 'all'){
                Data = this.walletHistoryData;
            }
            else if(this.selectedStatus == 'processing'){
                Data = this.walletHistoryData?.filter((history) => ['reject_in_process','approve_in_process','hold'].includes(history.status))
            }
            else if(!['all', 'processing'].includes(this.selectedStatus)){
                Data = this.walletHistoryData?.filter((history) => history.status == this.selectedStatus)
            }
            if(this.selectedTransactionType == 1){
                Data = this.walletHistoryData?.filter((history) => ['client_deposit','manual_deposit'].includes(history.type))
            }
            else if(this.selectedTransactionType == 2){
                Data = this.walletHistoryData?.filter((history) => ['client_withdrawal','manual_withdrawal'].includes(history.type))
            }
            return Data;
        },
        transactionImageLists() {
            return this.currentImgUrl?.split(',')
        },
    },
    mounted(){
        const previousDate = this.$dateTime.getPreviousDate(30);
        this.formDates.fromDate = previousDate
        const currentDate = this.$dateTime.getcurrentDate() 
        this.formDates.toDate = currentDate;
        this.getWalletHistory(true)
    },
    methods: {
        handleRefreshWalletHistory(index) {
            let spinElem = document.getElementById('spin'+index)
            spinElem.classList.add('fa-spin')
            const spinTimeout = setTimeout(() => {
                spinElem.classList.remove('fa-spin')
                clearTimeout(spinTimeout);
            }, 3000);
            this.getWalletHistory()
        },
        toTitleCaseWithSpaces(str) {
            return str.split('_')[0] + ' ' + str.split('_')[1] ;
        },
        async cancelRequest(id){
            try{
                let response = await cancelRequest(id);
                this.getWalletHistory()
            }
            catch(error){
                console.log('cancelRequest', error)
            }
        },
        ShowNote(txt){
            if(txt == 'null' || txt == '' || txt == null) 
                return '-';
            else
                return txt;
        },
        async getWalletHistory(changedStatus = false) {
            try{
                this.spinClass = true;
                this.selectedDates = JSON.parse(JSON.stringify(this.formDates))
                let response = await getWalletHistory(this.formDates)
                if(!response?.error){
                    const spinTimeout = setTimeout(() => {
                        this.spinClass = false;
                    }, 2000);
                    this.walletHistoryData = response?.walletHistoryData;
                }
            }
            catch(error){
                this.spinClass = false;
                console.log(error)
            }
        },
        fetchSelectedOptions(){
            let selectedOptions = [];
            this.options.forEach(opt=>{
                if(opt.selected){
                    selectedOptions.push(opt.value);
                }   
            })
            return selectedOptions.join(',')
        },  
        getTransactionStatus     
    },
}
</script>
<style scoped>
    .imgSize{
        object-fit: contain;
        height:200px
    }
</style>